import createCache from '@emotion/cache';

// Anchors Emotion's runtime <style> injection to the <meta name="emotion-insertion-point">
// marker in public/index.html instead of always jumping to document.head's first child —
// keeps <meta charset> ahead of it so react-snap's prerendered output never buries the
// charset declaration behind injected styles (see async-baking-kay.md for the bug this fixes).
export default function createEmotionCache() {
    const insertionPoint = document.querySelector('meta[name="emotion-insertion-point"]');
    return createCache({ key: 'css', insertionPoint: insertionPoint || undefined });
}
